import { TableCacheKeyDto } from '@asset-metrix/portal-gateway-client-js';
import { useMutation } from '@tanstack/react-query';

import { createFopiTableRow } from '../api/portalGateway/createFopiTableRow';
import { invalidateTable } from '../utils/queryCacheHelper';

type UseCreateFopiTableRowParams = {
  cacheKey: TableCacheKeyDto;
  pageId: string;
  widgetId: string;
};

export function useCreateFopiTableRow({
  cacheKey,
  pageId,
  widgetId,
}: UseCreateFopiTableRowParams) {
  const { mutate, error, reset, status } = useMutation({
    mutationFn: createFopiTableRow,
    onSuccess: async () => {
      await invalidateTable(cacheKey, pageId, widgetId);
    },
  });

  return {
    error,
    status,
    reset,
    createFopiTableRow: (
      contentId: string,
      data: Record<string, unknown>,
      files: File[],
      onSuccess?: () => void
    ) => {
      return mutate({ contentId, data, files }, { onSuccess });
    },
  };
}
